// src/data/modalityTaxonomy.js
// Approved taxonomy — March 2, 2026
// 8 parent categories, 94 specific modalities
// Do not add or remove modalities without updating DF-Modality-Taxonomy.md

export const MODALITY_TAXONOMY = [
  {
    id: 'divination',
    icon: '✨',
    name: 'Divination & Intuitive Arts',
    description: 'Reading signs, symbols, and intuitive impressions to provide insight and guidance.',
    modalities: [
      { id: 'divination-tarot',               name: 'Tarot',                parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-oracle-cards',         name: 'Oracle Cards',         parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-runes',                name: 'Runes',                parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-pendulum',             name: 'Pendulum',             parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-psychic-readings',     name: 'Psychic Readings',     parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-intuitive-readings',   name: 'Intuitive Readings',   parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-scrying',              name: 'Scrying',              parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-i-ching',              name: 'I Ching',              parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-palmistry',            name: 'Palmistry',            parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-face-reading',         name: 'Face Reading',         parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-feet-reading',         name: 'Feet Reading',         parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-tea-leaf-reading',     name: 'Tea Leaf Reading',     parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-bone-reading',         name: 'Bone Reading',         parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-bibliomancy',          name: 'Bibliomancy',          parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-cartomancy',           name: 'Cartomancy',           parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-dowsing',              name: 'Dowsing',              parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-automatic-writing',    name: 'Automatic Writing',    parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-lithomancy',           name: 'Lithomancy',           parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-aura-reading',         name: 'Aura Reading',         parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
      { id: 'divination-dream-interpretation', name: 'Dream Interpretation', parentId: 'divination', parentName: 'Divination & Intuitive Arts' },
    ],
  },
  {
    id: 'astrology',
    icon: '🌙',
    name: 'Astrology & Chart-Based Practices',
    description: 'Systems that use birth data, numbers, or cosmic positioning to map personality, timing, and life patterns.',
    modalities: [
      { id: 'astrology-western',        name: 'Western Astrology',         parentId: 'astrology', parentName: 'Astrology & Chart-Based Practices' },
      { id: 'astrology-vedic',          name: 'Vedic Astrology (Jyotish)', parentId: 'astrology', parentName: 'Astrology & Chart-Based Practices' },
      { id: 'astrology-korean-saju',    name: 'Korean Saju',               parentId: 'astrology', parentName: 'Astrology & Chart-Based Practices' },
      { id: 'astrology-chinese',        name: 'Chinese Astrology',         parentId: 'astrology', parentName: 'Astrology & Chart-Based Practices' },
      { id: 'astrology-numerology',     name: 'Numerology',                parentId: 'astrology', parentName: 'Astrology & Chart-Based Practices' },
      { id: 'astrology-human-design',   name: 'Human Design',              parentId: 'astrology', parentName: 'Astrology & Chart-Based Practices' },
      { id: 'astrology-mayan',          name: 'Mayan Astrology',           parentId: 'astrology', parentName: 'Astrology & Chart-Based Practices' },
      { id: 'astrology-hellenistic',    name: 'Hellenistic Astrology',     parentId: 'astrology', parentName: 'Astrology & Chart-Based Practices' },
      { id: 'astrology-evolutionary',   name: 'Evolutionary Astrology',    parentId: 'astrology', parentName: 'Astrology & Chart-Based Practices' },
      { id: 'astrology-horary',         name: 'Horary Astrology',          parentId: 'astrology', parentName: 'Astrology & Chart-Based Practices' },
    ],
  },
  {
    id: 'energy',
    icon: '💫',
    name: 'Energy Work & Healing',
    description: "Working with the body's energy systems and environmental energy to promote balance, release blockages, and support healing.",
    modalities: [
      { id: 'energy-reiki',            name: 'Reiki',            parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-pranic-healing',   name: 'Pranic Healing',   parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-chakra-balancing', name: 'Chakra Balancing', parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-crystal-healing',  name: 'Crystal Healing',  parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-sound-healing',    name: 'Sound Healing',    parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-sound-bath',       name: 'Sound Bath',       parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-qi-gong',          name: 'Qi Gong',          parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-healing-touch',    name: 'Healing Touch',    parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-biofield-tuning',  name: 'Biofield Tuning',  parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-acupressure',      name: 'Acupressure',      parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-eft-tapping',      name: 'EFT / Tapping',    parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-theta-healing',    name: 'Theta Healing',    parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-quantum-healing',  name: 'Quantum Healing',  parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-polarity-therapy', name: 'Polarity Therapy', parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-feng-shui',        name: 'Feng Shui',        parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-vastu',            name: 'Vastu',            parentId: 'energy', parentName: 'Energy Work & Healing' },
      { id: 'energy-sacred-geometry',  name: 'Sacred Geometry',  parentId: 'energy', parentName: 'Energy Work & Healing' },
    ],
  },
  {
    id: 'mind-body',
    icon: '🧘',
    name: 'Mind-Body Practices',
    description: 'Techniques that use the mind-body connection for transformation, awareness, and well-being.',
    modalities: [
      { id: 'mind-body-meditation',           name: 'Meditation',                        parentId: 'mind-body', parentName: 'Mind-Body Practices' },
      { id: 'mind-body-breathwork',           name: 'Breathwork',                        parentId: 'mind-body', parentName: 'Mind-Body Practices' },
      { id: 'mind-body-somatic-therapy',      name: 'Somatic Therapy',                   parentId: 'mind-body', parentName: 'Mind-Body Practices' },
      { id: 'mind-body-hypnotherapy',         name: 'Hypnotherapy',                      parentId: 'mind-body', parentName: 'Mind-Body Practices' },
      { id: 'mind-body-yoga-therapy',         name: 'Yoga Therapy',                      parentId: 'mind-body', parentName: 'Mind-Body Practices' },
      { id: 'mind-body-mindfulness',          name: 'Mindfulness',                       parentId: 'mind-body', parentName: 'Mind-Body Practices' },
      { id: 'mind-body-guided-visualization', name: 'Guided Visualization',              parentId: 'mind-body', parentName: 'Mind-Body Practices' },
      { id: 'mind-body-past-life-regression', name: 'Past Life Regression',              parentId: 'mind-body', parentName: 'Mind-Body Practices' },
      { id: 'mind-body-nlp',                  name: 'Neuro-Linguistic Programming (NLP)', parentId: 'mind-body', parentName: 'Mind-Body Practices' },
      { id: 'mind-body-tai-chi',              name: 'Tai Chi',                           parentId: 'mind-body', parentName: 'Mind-Body Practices' },
    ],
  },
  {
    id: 'mediumship',
    icon: '🔮',
    name: 'Mediumship & Spirit Communication',
    description: 'Connecting with non-physical beings, spirit guides, ancestors, and higher realms of consciousness.',
    modalities: [
      { id: 'mediumship-mediumship',          name: 'Mediumship',                parentId: 'mediumship', parentName: 'Mediumship & Spirit Communication' },
      { id: 'mediumship-channeling',          name: 'Channeling',                parentId: 'mediumship', parentName: 'Mediumship & Spirit Communication' },
      { id: 'mediumship-akashic-records',     name: 'Akashic Records',           parentId: 'mediumship', parentName: 'Mediumship & Spirit Communication' },
      { id: 'mediumship-spirit-guide',        name: 'Spirit Guide Communication', parentId: 'mediumship', parentName: 'Mediumship & Spirit Communication' },
      { id: 'mediumship-ancestral-work',      name: 'Ancestral Work',            parentId: 'mediumship', parentName: 'Mediumship & Spirit Communication' },
      { id: 'mediumship-angel-communication', name: 'Angel Communication',       parentId: 'mediumship', parentName: 'Mediumship & Spirit Communication' },
      { id: 'mediumship-animal-communication',name: 'Animal Communication',      parentId: 'mediumship', parentName: 'Mediumship & Spirit Communication' },
      { id: 'mediumship-psychopomp',          name: 'Psychopomp Work',           parentId: 'mediumship', parentName: 'Mediumship & Spirit Communication' },
    ],
  },
  {
    id: 'ceremonial',
    icon: '🕯️',
    name: 'Ceremonial & Ritual Arts',
    description: 'Sacred practices, ceremonies, and intentional rituals from various traditions.',
    modalities: [
      { id: 'ceremonial-spellwork',           name: 'Spellwork',                  parentId: 'ceremonial', parentName: 'Ceremonial & Ritual Arts' },
      { id: 'ceremonial-ritual-facilitation', name: 'Ritual Facilitation',        parentId: 'ceremonial', parentName: 'Ceremonial & Ritual Arts' },
      { id: 'ceremonial-shamanic-practice',   name: 'Shamanic Practice',          parentId: 'ceremonial', parentName: 'Ceremonial & Ritual Arts' },
      { id: 'ceremonial-healing',             name: 'Ceremonial Healing',         parentId: 'ceremonial', parentName: 'Ceremonial & Ritual Arts' },
      { id: 'ceremonial-sacred-ceremony',     name: 'Sacred Ceremony',            parentId: 'ceremonial', parentName: 'Ceremonial & Ritual Arts' },
      { id: 'ceremonial-curanderismo',        name: 'Curanderismo',               parentId: 'ceremonial', parentName: 'Ceremonial & Ritual Arts' },
      { id: 'ceremonial-hoodoo-rootwork',     name: 'Hoodoo / Rootwork',          parentId: 'ceremonial', parentName: 'Ceremonial & Ritual Arts' },
      { id: 'ceremonial-moon-rituals',        name: 'Moon Rituals',               parentId: 'ceremonial', parentName: 'Ceremonial & Ritual Arts' },
      { id: 'ceremonial-smudging',            name: 'Smudging / Smoke Cleansing', parentId: 'ceremonial', parentName: 'Ceremonial & Ritual Arts' },
      { id: 'ceremonial-space-clearing',      name: 'Space Clearing',             parentId: 'ceremonial', parentName: 'Ceremonial & Ritual Arts' },
      { id: 'ceremonial-manifestation',       name: 'Manifestation Work',         parentId: 'ceremonial', parentName: 'Ceremonial & Ritual Arts' },
      { id: 'ceremonial-cord-cutting',        name: 'Cord Cutting',               parentId: 'ceremonial', parentName: 'Ceremonial & Ritual Arts' },
    ],
  },
  {
    id: 'coaching',
    icon: '🌱',
    name: 'Coaching & Guidance',
    description: 'Professional guidance, mentoring, and development for personal growth, business, and spiritual evolution.',
    modalities: [
      { id: 'coaching-life',               name: 'Life Coaching',                       parentId: 'coaching', parentName: 'Coaching & Guidance' },
      { id: 'coaching-spiritual',          name: 'Spiritual Coaching',                  parentId: 'coaching', parentName: 'Coaching & Guidance' },
      { id: 'coaching-intuitive',          name: 'Intuitive Coaching',                  parentId: 'coaching', parentName: 'Coaching & Guidance' },
      { id: 'coaching-business',           name: 'Business Coaching for Practitioners', parentId: 'coaching', parentName: 'Coaching & Guidance' },
      { id: 'coaching-grief',              name: 'Grief Coaching',                      parentId: 'coaching', parentName: 'Coaching & Guidance' },
      { id: 'coaching-relationship',       name: 'Relationship Coaching',               parentId: 'coaching', parentName: 'Coaching & Guidance' },
      { id: 'coaching-wellness',           name: 'Wellness Coaching',                   parentId: 'coaching', parentName: 'Coaching & Guidance' },
      { id: 'coaching-transformational',   name: 'Transformational Coaching',           parentId: 'coaching', parentName: 'Coaching & Guidance' },
      { id: 'coaching-inner-child',        name: 'Inner Child Work',                    parentId: 'coaching', parentName: 'Coaching & Guidance' },
      { id: 'coaching-shadow-work',        name: 'Shadow Work',                         parentId: 'coaching', parentName: 'Coaching & Guidance' },
      { id: 'coaching-psychic-development',name: 'Psychic Development',                 parentId: 'coaching', parentName: 'Coaching & Guidance' },
    ],
  },
  {
    id: 'herbalism',
    icon: '🌿',
    name: 'Herbalism & Plant Medicine',
    description: 'Working with plants, herbs, and natural remedies for healing, wellness, and spiritual connection.',
    modalities: [
      { id: 'herbalism-herbalism',       name: 'Herbalism',                parentId: 'herbalism', parentName: 'Herbalism & Plant Medicine' },
      { id: 'herbalism-plant-spirit',    name: 'Plant Spirit Medicine',    parentId: 'herbalism', parentName: 'Herbalism & Plant Medicine' },
      { id: 'herbalism-flower-essences', name: 'Flower Essences',          parentId: 'herbalism', parentName: 'Herbalism & Plant Medicine' },
      { id: 'herbalism-aromatherapy',    name: 'Aromatherapy',             parentId: 'herbalism', parentName: 'Herbalism & Plant Medicine' },
      { id: 'herbalism-ethnobotany',     name: 'Ethnobotany',              parentId: 'herbalism', parentName: 'Herbalism & Plant Medicine' },
      { id: 'herbalism-foraging',        name: 'Foraging & Wild Crafting', parentId: 'herbalism', parentName: 'Herbalism & Plant Medicine' },
    ],
  },
];

// ─── Derived exports ──────────────────────────────────────────────────────────

/** Just the 8 parent categories — id, name, description, icon, modality count. */
export const PARENT_CATEGORIES = MODALITY_TAXONOMY.map(({ id, name, description, icon, modalities }) => ({
  id,
  name,
  description,
  icon,
  count: modalities.length,
}));

/** Flat array of all 94 specific modalities. */
export const ALL_MODALITIES = MODALITY_TAXONOMY.flatMap((parent) => parent.modalities);

// ─── Helper functions ─────────────────────────────────────────────────────────

/**
 * Returns the parent category object (with its modalities array) for a given
 * modality id (e.g. 'divination-tarot').
 * Returns undefined if the id is not found.
 */
export function getParentForModality(modalityId) {
  return MODALITY_TAXONOMY.find((parent) =>
    parent.modalities.some((m) => m.id === modalityId)
  );
}

/**
 * Returns a subset of modalities for public-facing display (e.g., profile cards, directory).
 * @param {Array} selectedModalities - Array of modality objects { id, name, ... }
 * @param {number} maxDisplay - Max items to show before truncating (default 3)
 * @returns {{ display: Array, remaining: number }}
 */
export function getDisplayModalities(selectedModalities, maxDisplay = 3) {
  if (!Array.isArray(selectedModalities)) return { display: [], remaining: 0 };
  const display = selectedModalities.slice(0, maxDisplay);
  const remaining = Math.max(0, selectedModalities.length - maxDisplay);
  return { display, remaining };
}

/**
 * Case-insensitive search across all modality names.
 * Returns matching modality objects (each already includes parentId / parentName).
 *
 * @param {string} query
 * @returns {{ id, name, parentId, parentName }[]}
 */
export function searchModalities(query) {
  if (!query || !query.trim()) return [];
  const q = query.trim().toLowerCase();
  return ALL_MODALITIES.filter((m) => m.name.toLowerCase().includes(q));
}
